import { render, staticRenderFns } from "./elementsSearch.vue?vue&type=template&id=f2fb6602"
import script from "./elementsSearch.ts?vue&type=script&lang=js&external"
export * from "./elementsSearch.ts?vue&type=script&lang=js&external"
import style0 from "./elementsSearch.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports